import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import IconArrow from "assets/svg/chevron_left_arrow.svg";

import styles from "./styles.module.css";
import { numberFormatter } from "helpers/number-formatter";

const Pagination = ({ totalItems, itemsPerPage, onPageChange }) => {
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handlePageChange = (page) => {
    const isInvalidSelection = page < 1 || page > totalPages || page === currentPage;
    if (isInvalidSelection) return;
    setCurrentPage(page);
    onPageChange(page - 1);
  };

  const renderPageNumbers = () =>
    Array.from({ length: totalPages }, (_, index) => {
      const pageNumber = index + 1;
      const pageNumbersClasses = classNames({ [styles.pageNumber]: true, [styles.active]: currentPage === pageNumber });
      return (
        <div key={pageNumber} className={pageNumbersClasses} onClick={() => handlePageChange(pageNumber)}>
          {pageNumber}
        </div>
      );
    });

  const startItemIndex = (currentPage - 1) * itemsPerPage + 1;
  const endItemIndex = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <div className={styles.pagination}>
      <div className={styles.numberContainer}>
        <div className={styles.pageItem} onClick={() => handlePageChange(currentPage - 1)}>
          <IconArrow />
        </div>
        <div className={styles.numbers}>{renderPageNumbers()}</div>

        <div className={styles.pageItemRight} onClick={() => handlePageChange(currentPage + 1)}>
          <IconArrow />
        </div>
      </div>
      {totalItems > 1 && (
        <div className={styles.paginationInfo}>
          {`${numberFormatter(startItemIndex)} - ${numberFormatter(endItemIndex)} arasındaki ilanlar listeleniyor`}
        </div>
      )}
    </div>
  );
};

Pagination.propTypes = {
  totalItems: PropTypes.number,
  itemsPerPage: PropTypes.number,
  onPageChange: PropTypes.func,
  currentLanguage: PropTypes.string,
};

export default Pagination;
